module.exports = __webpack_public_path__ + "media/src/img/watercolor-2dcd4a0586e88c474961b6c5fd1c9799.svg";